import { get } from './index';
import { ApiResponse, TotalUserListManagement, UserListManagement, UserListManagementResult } from '../types';

export async function getUserManagementInfo(skip: number, limit: number, email?: string): Promise<UserListManagement> {
  let url = `/admin/member-management/list?limit=${limit}&skip=${skip}`;
  if (email) {
    url += `&email=${email}`;
  }
  const response = await get<ApiResponse<UserListManagement>>(url);
  return response.data as UserListManagement;
}

export async function getTotalUserManagementInfo() {
  let url = '/admin/member-management/total';
  const response = await get<ApiResponse<TotalUserListManagement>>(url);
  return response.data as TotalUserListManagement;
}
